import { render, staticRenderFns } from "./FullPage.vue?vue&type=template&id=40e0f13f&scoped=true&"
import script from "./FullPage.js?vue&type=script&lang=js&"
export * from "./FullPage.js?vue&type=script&lang=js&"
import style0 from "./FullPage.scss?vue&type=style&index=0&id=40e0f13f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e0f13f",
  null
  
)

export default component.exports